import React, { useId } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children, className = '' }) => {
  const tooltipId = useId();

  return (
    <div className={`relative group inline-flex ${className}`}>
      <div 
        className="cursor-help"
        aria-describedby={tooltipId}
      >
        {children}
      </div>
      <div
        role="tooltip"
        id={tooltipId}
        className="pointer-events-none absolute bottom-full left-1/2 z-[60] mb-2 w-[min(16rem,calc(100vw-2rem))] -translate-x-1/2 rounded-lg bg-gray-900 px-3 py-2 text-xs text-white text-center opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100"
        style={{ backgroundColor: '#111827' }}
      >
        {content}
        {/* Arrow pointing down */}
        <span 
          className="absolute top-full left-1/2 -translate-x-1/2 border-[6px] border-transparent border-t-gray-900"
          style={{ borderTopColor: '#111827' }}
        ></span>
      </div>
    </div>
  );
};

export default Tooltip;
